import React from 'react'
import { Button } from 'react-bootstrap'

class LoadingButton extends React.Component {

  render() {
    const { loading, bsStyle, children, onClick } = this.props
    return (
      <Button bsStyle={bsStyle} disabled={loading} onClick={!loading ? onClick : null}>
        {loading ? <span className='fa fa-circle-o-notch fa-spin fa-3x fa-fw'/> : children}
      </Button>
    )
  }
}

export default LoadingButton



// WEBPACK FOOTER //
// ./src/components/widgets/LoadingButton.js